import {
  DjangoLegacyQueryParams,
  DjangoQueryParams,
  PaginationAdapter,
} from "./pagination.types";

// This should be the default moving forward to work better with DRF and Django Filters
export const DjangoPaginationAdapter: PaginationAdapter<DjangoQueryParams> = {
  toParams: (queryParams) => ({
    limit: queryParams.pageSize.toString(),
    offset: (queryParams.page * queryParams.pageSize).toString(),
    ordering:
      queryParams.sort.direction === "desc"
        ? `-${queryParams.sort.field}`
        : queryParams.sort.field,
    search: queryParams.search,
  }),
};

// This one will probably get more usage though with the existing couplings
// of MaterialTable props and the backend
export const DjangoLegacyPaginationAdapter: PaginationAdapter<DjangoLegacyQueryParams> =
  {
    toParams: (queryParams) => ({
      limit: queryParams.pageSize.toString(),
      offset: (queryParams.page * queryParams.pageSize).toString(),
      orderBy: queryParams.sort.field,
      orderDirection: queryParams.sort.direction,
      search: queryParams.search,
    }),
  };
